import { jsDayIndexToDayMap } from '@reservation-app/common-used-in-web';
export const getDayFromDate = (date) => {
    return jsDayIndexToDayMap[new Date(date).getDay()];
};
